import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { timeout } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { FuncionesResponse } from "../interfaces/funciones-interface";
import { setPromotionStatus } from "../tools/tools";
export let tokenRoga =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJGcmFuY2lzY28gU2FtdWVsIEhlcm5hbmRleiBSb2RyaWd1ZXoiLCJ1c3VhcmlvIjozNzQ0LCJub21icmVVc3VhcmlvIjoiRnJhbmNpc2NvIFNhbXVlbCBIZXJuYW5kZXogUm9kcmlndWV6IiwiY2VkaXMiOjEsInN1Y3Vyc2FsIjo5NiwidXNlclByb2ZpbGUiOjAsImFwcElkIjoxLCJtYWNBZGRyZXNzIjoiQUhER1dCSlNHNSJ9.WSEF1uq3Vvxgf--X-IaJW1ZCVbvBDW4L-u1pwLBrOyXDyz-Tt27NuZuUAYH2f9FRGWBiURMXxODJWCsJBhFSEg";
export const TIMEOUT = 60000;

const URL_FUNCTIONS = environment.urlServices + "/rogacore/consultaFunciones/";

const headers = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({ providedIn: "root" })
export class ConfigService {
  confCargadas = false;
  errorConf = false;

  constructor(private http: HttpClient) {
    this.initConfig();
  }

  async initConfig(): Promise<void> {
    try {
      this.errorConf = false;
      this.confCargadas = false;

      tokenRoga = await this.setLoginUserRoga();
      const funciones = await this.getFuncionesRT(
        1,
        environment.userRoga.userId,
        environment.userRoga.idSucursal,
      );

      const funcionbf = funciones.find((fun) => fun.idFuncionAplicacion === 1);
      
      // const funcionbf = {
      //     estado: "Activa",
      //     idCedis: 1,
      //     idFuncionAplicacion: 1,
      //     idFuncionLiberadaAplicacion: 1,
      //     idSucursal: -1,
      //     idUsuario: -1,
      //     nombreFuncion: "35 Aniversario del: 18 Agosto al 31 Octubre",
      //     aplicaVigencia: true,
      //     fechaInicio: "2026-08-01 00:00:00.0",
      //     fechaFin: "2026-10-31 23:59:59.0",
      //   };

      console.log("🚀 ~ ConfigService ~ initConfig ~ funcionbf:", funcionbf);

      if (funcionbf && funcionbf.estado === "Activa") {
        if (funcionbf.aplicaVigencia) {
          setPromotionStatus(true, funcionbf.nombreFuncion, funcionbf.fechaInicio, funcionbf.fechaFin);
        } else {
          setPromotionStatus(true, funcionbf.nombreFuncion);
        }
      } else {
        setPromotionStatus(false);
      }

      this.confCargadas = true;
    } catch (error) {
      this.confCargadas = false;
      this.errorConf = true;
      console.error("Error al cargar configuración:", error);
    }
  }

  retryLoadingConfigs(): void {
    this.initConfig();
  }

  private setLoginUserRoga() {
    // console.log(environment.userRoga);

    return new Promise<any>((resolve, reject) => {
      return this.http
        .post(
          environment.loginRoga,
          JSON.stringify(environment.userRoga),
          headers,
        )
        .pipe(timeout(TIMEOUT))
        .subscribe(
          (authUser: any) => resolve(authUser.token),
          (err) => {
            console.log(err);

            reject(err);
          },
        );
    });
  }

  getFuncionesRT(
    idCentro: number,
    idSucursal: number,
    idUsuario: number,
  ): Promise<FuncionesResponse[]> {
    return new Promise((resolve, reject) => {
      const url = `${URL_FUNCTIONS}?idCedis=${idCentro}&idSucursal=${idSucursal}&idUsuario=${idUsuario}`;

      return this.http
        .get<FuncionesResponse[]>(url, this.headersRoga())
        .subscribe(
          (resp) => resolve(resp),
          (err) => {
            console.log(err);
            reject(err);
          },
        );
    });
  }
  headersRoga() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        RogaServiceAuth: "Token " + tokenRoga,
      }),
    };
  }
}
